import { ABSCHREIBUNG_MAX, CAPS, ZUSTAND } from './catalogs.js';
/**
 * Berechnungskern der Wertermittlung — pure functions, keine I/O.
 * Fachliche Grundlage: Sachwertverfahren der LBK-Richtlinie, mit jährlichem
 * Anpassungsfaktor des Landesverbands statt Baukostenindex.
 * Formel Baulichkeiten: Richtwert × Fläche × Faktor − Abschreibung(Alter × Satz)
 * Formel Positionen:    Richtwert × Menge  × Faktor × (1 − Wertminderung)
 * Beträge werden je Position kaufmännisch auf Cent gerundet.
 */
export const round2 = (v) => Math.round((v + Number.EPSILON) * 100) / 100;
export function calcBauteil(b, faktor, bewertungsjahr) {
    const alter = b.baujahr ? Math.max(0, bewertungsjahr - b.baujahr) : 0;
    const satz = ZUSTAND[b.zustand]?.satz ?? 3.5;
    const abschreibung = Math.min(alter * satz, ABSCHREIBUNG_MAX);
    const basis = b.rw * (b.flaeche ?? 0) * faktor;
    return {
        alter,
        satz,
        abschreibung,
        zeitwert: round2(Math.max(0, basis * (1 - abschreibung / 100))),
    };
}
export function calcPos(p, faktor) {
    return round2(Math.max(0, p.preis * p.menge * faktor * (1 - p.minderung / 100)));
}
export function berechneSummen(data, faktor, bewertungsjahr) {
    const bau = round2(data.bauteile.reduce((s, b) => s + calcBauteil(b, faktor, bewertungsjahr).zeitwert, 0));
    const neben = round2(data.pos.neben.reduce((s, p) => s + calcPos(p, faktor), 0));
    const kulturenZwischen = round2(data.pos.kulturen.reduce((s, p) => s + calcPos(p, faktor), 0));
    const kulturen = round2(kulturenZwischen * (1 - data.pflege.kulturen / 100));
    // Zierbegrünung: Gruppensummen mit Höchstwert-Deckelung (Richtlinie)
    const gruppen = { zg: 0, st: 0, ra: 0, other: 0 };
    for (const p of data.pos.zier) {
        const key = p.g && p.g in gruppen ? p.g : 'other';
        gruppen[key] = round2(gruppen[key] + calcPos(p, faktor));
    }
    const gedeckelt = [];
    let zierZwischen = round2(gruppen.ra + gruppen.other);
    for (const key of ['zg', 'st']) {
        if (gruppen[key] > CAPS[key].max) {
            gedeckelt.push({ ...CAPS[key], ist: gruppen[key] });
            zierZwischen = round2(zierZwischen + CAPS[key].max);
        }
        else {
            zierZwischen = round2(zierZwischen + gruppen[key]);
        }
    }
    const zier = round2(zierZwischen * (1 - data.pflege.zier / 100));
    const abzuege = round2(data.abz.reduce((s, a) => s + a.betrag, 0));
    const gemeinschaft = round2(data.gemeinschaft);
    const entschaedigung = round2(bau + neben + kulturen + zier + gemeinschaft - abzuege);
    return {
        bau,
        neben,
        kulturenZwischen,
        kulturen,
        zierZwischen,
        zier,
        gedeckelt,
        abzuege,
        gemeinschaft,
        entschaedigung,
    };
}
//# sourceMappingURL=calc.js.map